<div class="details-body-wrapper">
  <div class="table-wrapper">
    <div class="table-responsive">
      <table
        matSort
        (matSortChange)="sortData($event)"
        matSortActive="{{ active }}"
        [matSortDirection]="direction"
      >
        <thead>
          <tr>
            <th mat-sort-header="id">
              {{ "GENERALS.ID" | translate }}
            </th>
            <th mat-sort-header="created_at">
              {{ "GENERALS.CREATED-AT" | translate }}
            </th>
            <th mat-sort-header="amount">
              {{ "GENERALS.AMOUNT" | translate }} /
              {{ "GENERALS.CURRENCY" | translate }}
            </th>
            <th mat-sort-header="funds_needed_by">Funds needed by</th>
            <th mat-sort-header="status">
              {{ "GENERALS.STATUS" | translate }}
            </th>
          </tr>
        </thead>

        <tbody *ngIf="isLoadingGeneral">
          <tr>
            <td colspan="100">
              <app-loader-spinner-general
                [loadingType]="LoadingType.TABLE"
              ></app-loader-spinner-general>
            </td>
          </tr>
        </tbody>

        <tbody *ngIf="!isLoadingGeneral">
          <tr
            *ngFor="
              let item of items
                | paginate
                  : {
                      itemsPerPage: itemsPage,
                      currentPage: p,
                      totalItems: total
                    }
            "
            class="clickable-row"
            (click)="goToFundingRequest(item.id)"
          >
            <td>{{ item.id }}</td>
            <td>
              {{ item.created_at ? (item.created_at | date : "medium") : "-" }}
            </td>
            <td>{{ item.amount | number : "1.2-2" }} {{ item.currency }}</td>
            <td>
              {{ item.funds_needed_by ? (item.funds_needed_by | date) : "-" }}
            </td>
            <td>{{ item.status | titlecase }}</td>
          </tr>

          <tr *ngIf="items?.length === 0">
            <td colspan="5" class="gray">
              {{ "GENERALS.NO-ITEMS-DISPLAY" | translate }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="paginator">
      <pagination-controls
        (pageChange)="navigateByUrl($event)"
        previousLabel=""
        nextLabel=""
      >
      </pagination-controls>
    </div>
  </div>
</div>
